<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getDepartments");
    this.$store.dispatch("lookups/getSpecialties");
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    departments() {
      return this.$store.state.lookups.departments;
    },
    specialties() {
      return this.$store.state.lookups.specialties;
    },
    paymentTypes() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.paymentTypes
        )];
    },
    gender() {
      return [
        { value: 2, label: "انثي" },
        { value: 1, label: "ذكر" },
      ]
    },

  },
  data() {
    return {
      vm: {
        birthDate: null,
        gender: null,
        firstName: null,
        labelName: null,

        operatingExpenseRatio: null,
        qualificationId: null,
        email: null,
        phoneNo: null,
        specialtyId: null,
      },

    };
  },
  methods: {
    ChangePaymentType() {
      this.vm.fixedSalary = null;
      this.vm.commissionRate = null;
    },
    confirm() {
      this.$store
        .dispatch("doctors/add", this.vm)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>